"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VendorCompanyInfoPageActions;
(function (VendorCompanyInfoPageActions) {
    VendorCompanyInfoPageActions["DataLoaded"] = "DataLoaded";
    VendorCompanyInfoPageActions["RecordUpdated"] = "RecordUpdated";
})(VendorCompanyInfoPageActions || (VendorCompanyInfoPageActions = {}));
exports.default = VendorCompanyInfoPageActions;
